var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.625C10.7625 2.625 2.625 10.7625 2.625 21C2.625 31.2375 10.7625 39.375 21 39.375C31.2375 39.375 39.375 31.2375 39.375 21C39.375 10.7625 31.2375 2.625 21 2.625ZM28.0875 30.1875L21 23.1L13.9125 30.1875L11.8125 28.0875L18.9 21L11.8125 13.9125L13.9125 11.8125L21 18.9L28.0875 11.8125L30.1875 13.9125L23.1 21L30.1875 28.0875L28.0875 30.1875Z",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4e6b41f9a2a3d5bcc4ef999a8857d973.svg";
export { ForwardRef as ReactComponent };